export default __webpack_public_path__ + "static/media/CNo.89-4.f69bdb57.jpg";